export default "__VITE_ASSET__LQY_W8XJ__"